export const DebtorHistoryStatus = Object.freeze({
  normal: 'normal',
  warning: 'warning',
});

export const DebtorHistoryStatusRange = Object.freeze({
  [DebtorHistoryStatus.normal]: 30,
});
